// WordSymbolDisplay.jsx
import React, { useEffect, useState } from "react"

const symbols = ["·", "✢", "✳", "✶", "✻", "✽"]
const words = [
  "Accomplishing",
  "Actioning",
  "Actualizing",
  "Calculating",
  "Channelling",
  "Coalescing",
  "Computing",
  "Combobulating",
  "Concocting",
  "Considering",
  "Contemplating",
  "Crafting",
  "Creating",
  "Crunching",
  "Deciphering",
  "Deliberating",
  "Determining",
  "Doing",
  "Effecting",
  "Elucidating",
  "Envisioning",
  "Finagling",
  "Forming",
  "Generating",
  "Ideating",
  "Imagining",
  "Inferring",
  "Manifesting",
  "Mulling",
  "Mustering",
  "Musing",
  "Percolating",
  "Perusing",
  "Philosophising",
  "Pontificating",
  "Pondering",
  "Processing",
  "Puttering",
  "Puzzling",
  "Ruminating",
  "Scheming",
  "Synthesizing",
  "Thinking",
  "Tinkering",
  "Transmuting",
  "Unfurling",
  "Unravelling",
  "Working",
  "Wrangling",
]

const WordSymbolDisplay = () => {
  const [symbolIndex, setSymbolIndex] = useState(0)
  const [directionUp, setDirectionUp] = useState(true)
  const [currentWord, setCurrentWord] = useState("")

  // Update word every 10 seconds
  useEffect(() => {
    const updateWord = () => {
      const randomIndex = Math.floor(Math.random() * words.length)
      setCurrentWord(words[randomIndex] + "…")
    }
    updateWord() // initial word
    const wordInterval = setInterval(updateWord, 10000)

    return () => clearInterval(wordInterval)
  }, [])

  // Update symbol every 250ms
  useEffect(() => {
    const updateSymbol = () => {
      if (symbolIndex >= symbols.length - 1) {
        setDirectionUp(false)
      } else if (symbolIndex <= 0) {
        setDirectionUp(true)
      }

      setSymbolIndex(prev => (directionUp ? prev + 1 : prev - 1))
    }

    const symbolInterval = setInterval(updateSymbol, 250)
    return () => clearInterval(symbolInterval)
  }, [symbolIndex, directionUp])

  return (
    <div className="container-loading">
      <span id="symbol-loading">{symbols[symbolIndex]}</span>
      <span id="word-loading">{currentWord}</span>
    </div>
  )
}

export default WordSymbolDisplay
